<template>
  <div class="userAccount" title="User Account">
    <div class="userAccount__toggle" @click="userAccountModal = !userAccountModal">
      <i class="fas fa-user"></i>
    </div>
    <transition name="modalfadein" mode="in-out">
      <div class="userAccount__modal" v-show="userAccountModal">
        <form>
          <div class="inputText">
            <label class="inputText__label"></label>
            <div class="inputText__group">
              <div class="inputText__icon"><i class="fas fa-user"></i></div>
              <input class="inputText__input" placeholder="Username" type="text" id="userName" name="userName">
            </div>
            <div class="inputText__feedback"></div>
          </div>
          <div class="inputText">
            <label class="inputText__label"></label>
            <div class="inputText__group">
              <div class="inputText__icon"><i class="fas fa-key"></i></div>
              <input class="inputText__input" placeholder="Password" type="password" id="userPassword" name="userPassword">
            </div>
            <div class="inputText__feedback"></div>
          </div>
          <div class="userAccount__buttons">
            <button type="button" class="btn btn-sm mr-2" @click="userAccountModal = !userAccountModal">Close</button>
            <button class="btn btn-sm btn-primary">Log-in</button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UserAccount',
  data () {
    return {
      userAccountModal: false,
    }
  }
}
</script>

<style scoped lang="sass">
.userAccount
  cursor: pointer
  position: relative
  &:hover, &:active
    background-color: var(--color-overlay-10)
.userAccount__toggle
  width: 3.5rem
  display: flex
  justify-content: center
  align-items: center
  height: 3.5rem
.userAccount__modal
  position: absolute
  right: 0
  top: 3.5rem
  background-color: var(--color-surface)
  color: var(--color-onSurface)
  width: 200px
  padding: 1rem
  box-shadow: var(--z-1)
  border-radius: var(--b-radius-md)
.userAccount__buttons
  display: flex
  justify-content: space-between
  align-items: center
  .btn
    flex-basis: 50%
</style>
